import { diagnosisService } from "@/stores/services/diagnosisServices";
import { skipToken } from "@reduxjs/toolkit/query";

export function useFleetData(companyId: number, diagnosisId?: number) {
  const { data: fleetByCompany, isFetching: isLoadingFleetByCompany } =
    diagnosisService.useFindFleetsByCompanyIdQuery(
      diagnosisId && diagnosisId > 0
        ? { companyId, diagnosisId }
        : skipToken,
    );

  return {
    fleetByCompany,
    isLoadingFleetByCompany,
  };
}
